const dbs = ['mongo', 'cosmos', 'dynamodb'];

export function isNoSql(engineType: string | undefined) {
  return dbs.some((x) => engineType?.toLowerCase().includes(x));
}
